import React, { useState, useEffect, useContext } from 'react';

import { Modal, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { BsCircleFill } from 'react-icons/bs';
import { AiFillCheckCircle } from "react-icons/ai";
import { IoIosAddCircle } from "react-icons/io";
import { IoChevronBackCircle } from "react-icons/io5";
import Moment from 'react-moment';
import { BsCardChecklist, BsCloudUpload } from "react-icons/bs";

import FlightsService from '../../services/flights.servicse';
import AppButton from 'components/FormsUI/AppButton/appButton';
import AuthContext from 'store/AuthContext';
import NewFlightPopup from './NewFlightPopup';
import UpdateFlightPopup from './UpdateFlightPopup';
import FlightsHeader from './FlightsHeader';
import AppPagination from "components/common/AppPagination";
import AppSkeleton from 'components/common/skeleton/AppSkeleton';
import { AppTableNoData } from 'components/common/AppTableUtils';

import './FlightList.css';
import '../common/tables.css';
import ToastContext from 'store/ToastContext';
import FlightErrors from 'components/errors/flightErrors';

const FlightList = (props) => {
    const { userInfo } = useContext(AuthContext);
    const { openToast } = useContext(ToastContext);
    const [spinnerLoading, setSpinnerLoading] = useState(true);
    const [data, setData] = useState([]);
    const [show, setShow] = useState(false);
    const [selectedItem, setSelectedItem] = useState({});
    const [showCloseFlightBtn, setShowCloseFlightBtn] = useState(false);
    const [showCancelFlightBtn, setShowCancelFlightBtn] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [flight, setFlight] = useState();
    const [action, setAction] = useState("");
    const [showModalForUpdate, setShowModalForUpdate] = useState(false);
    const [message, setMessage] = useState("");
    const [activeId, setActiveId] = useState(null);
    const { location: { state: { airlineCode: selectedAirlineCode = null, flightId = null } = {} } } = props
    const [paginationObject, setPaginationObject] = useState({ currPage: 1, pageSize: 10, startIndex: 0, endIndex: 10 });
const [errorsData,setErrorsData]= useState([]);
const [showModalErrors,setShowModalErrors]=useState(false);

const backhandler = () => {
    props.history.goBack();
}

    useEffect(() => {
        const airlineCode = userInfo.isOwner ? selectedAirlineCode : userInfo.airlineCode;
        if(!airlineCode){
            backhandler();
        }
        FlightsService.getData(airlineCode)
            .then((flightRes) => {
               
                if (flightRes.length > 0) {
                    const sortedFlights = flightRes.sort((a, b) => b.flightDateTime.localeCompare(a.flightDateTime));

                    setData(sortedFlights);

                    if (flightId) {//???TOCHECK
                        const findUpdatedRowIndex = sortedFlights.findIndex((addedFlight) => addedFlight.id === flightId);
                        setActiveId(findUpdatedRowIndex);
                    }
                }
                setSpinnerLoading(false);
            }).catch((error) => {
                setData([]);
                setSpinnerLoading(false);
            });
    }, [userInfo.isOwner,selectedAirlineCode, userInfo.airlineCode,flightId,backhandler])

    useEffect(()=>{
        userInfo.isOwner ? setAction("View") : setAction("");
    }, [userInfo])


    const handleClose = () => {
        setSpinnerLoading(false);
        setShow(false);
        setShowModal(false);
        setShowModalForUpdate(false);
        setShowModalErrors(false);
    }

    const handleCloseFlight = async (selectedItem) => {
        setSpinnerLoading(true);
        const close = await FlightsService.closeFlight(selectedItem);

        if (close === 0) {
            var findUpdatedRowIndex = data.findIndex((emp) => emp.id === selectedItem.id);
            let newArr = [...data];
            selectedItem.clobReceived = true;
            newArr[findUpdatedRowIndex] = selectedItem;
            setData(newArr);
            openToast("Flight closed successfully", "success");
        }       
        else {
            openToast("There was an error in closing flight", "error");
        }
        setSpinnerLoading(false);
        setShow(false);
    }

    const redirectToPersons = (flight, personType) => {
        props.history.push({
            pathname: `/personList/${flight.id}/${personType}`
        })
    }

    const handleErrors = (flight) => {   
        if (flight.flight_Errors!==null){    
        setErrorsData(flight.flight_Errors);
        setShowModalErrors(true);}
    }

    const handleShow = async (item, action, index) => {
        if (action === "cancel") {
            setActiveId(index);
            setShowCancelFlightBtn(true);
            setShowCloseFlightBtn(false);
            setMessage('Are you sure you want to cancel the flight?');
        }
        if (action === "close") {
            setActiveId(index);
            setShowCancelFlightBtn(false);
            setShowCloseFlightBtn(true);
            setMessage('Are you sure you want to close the flight?')
        }
        setSelectedItem(item);
        setShow(true);
    }


    const redirectToUploadedFiles = () => {
        props.history.push({
            pathname: `/UploadedFilesList`,
            state: { airlineCode: selectedAirlineCode }
        })
    }

    const redirectToUploadFile = () => {
        props.history.push({
            pathname: `/UploadFile`
        })
    }

    const handleAddFlight = async (flight) => {
        setFlight(flight);
        setAction("Add");
        setActiveId(null);
        setShowModal(true);
    }
    const handleUpdateFlight = async (flight, index) => {
        setFlight(flight);
        setAction("Update");
        setShowModalForUpdate(true);
        setActiveId(index);
    }

    const onRowUpdateSubmitted = async (values, action) => {
        setSpinnerLoading(false);
        if (action === "Add") {
            setSpinnerLoading(true);
            setShowModal(false);
            FlightsService.getData()
                .then((flightRes) => {
                    if (flightRes.length > 0) {
                        const sortedFlights = flightRes.sort((a, b) => b.flightDateTime.localeCompare(a.flightDateTime));
                        values.id && setActiveId(sortedFlights.findIndex(f => f.id === values.id));
                        setData(sortedFlights);
                    }
                    setSpinnerLoading(false);
                }).catch((error) => {
                    setSpinnerLoading(false);
                    return error;
                });
        }
        if (action === "update") {
            var findUpdatedRowIndex = data.findIndex((flight) => flight.id === values.id);
            let newArr = [...data];
            newArr[findUpdatedRowIndex] = values;
            setData(newArr);
            setShowModalForUpdate(false);
        }
    }
    const handleCloseUpdateInsertPerson = () => { }
    const handleCloseErrorModal = () => { }
   

    const HandleCancelFlight = async (values) => {
        setSpinnerLoading(true);
        const del = await FlightsService.deleteFlight(values);
        if (del === 0) {
            var list = await FlightsService.getData();
            var sortedFlights = list.sort((a, b) => b.flightDateTime.localeCompare(a.flightDateTime));
            setData(sortedFlights);
            openToast("Flight canceled successfully", "success")
        }       
        else {
            openToast("An error occurred while trying to cancel the flight", "error")
        }
        setSpinnerLoading(false);
        setShow(false);
    }

    return (<>
        <div className="row p-3 align-items-center" >
            <div className="col-md-7">
            {userInfo.isOwner ? <h2 id="flights-list-title">View Flights for Airline {selectedAirlineCode}</h2>
            : <h2 id="flights-list-title">Flights for Airline {userInfo.airlineCode} - {userInfo.airline?.airline ? userInfo.airline.airline.toUpperCase() : ''}</h2>
            }
            </div>
            <div className="col-md-5">
                {!userInfo.isOwner && <React.Fragment>
                    <AppButton id="addFlightBtn" action={() => handleAddFlight(null)} label="Add flight" classes="rightBtn" icon={<IoIosAddCircle />}></AppButton>
                    <AppButton id="uploadFileBtn" color="warning" action={redirectToUploadFile} label="Upload File" classes="rightBtn margingRight" icon={<BsCloudUpload />}></AppButton>
                </React.Fragment>}
                <AppButton id="filesListBtn" action={redirectToUploadedFiles} label="Files List" classes="rightBtn margingRight" icon={<BsCardChecklist />}></AppButton>

            </div>
            {userInfo.isOwner && 
                <div className="col-12">
                    <FlightsHeader />
                </div>
            }
        </div>
        <div>
            {spinnerLoading ? <AppSkeleton rows={paginationObject.pageSize} cols={12} variant="table" size="28px"/> : (
                <React.Fragment>
                    <table className="table table-hover table-sm table-bordered">
                        <thead style={{ zIndex: 5 }}>
                            <tr>
                                <th scope="col">Status</th>
                                <th scope="col">Closed Flight</th>
                                <th scope="col">Flight Number</th>
                                <th scope="col">Departure Airport</th>
                                <th scope="col">Arrival Airport</th>
                                <th scope="col" style={{ width: '15%' }}>Flight Date and Time</th>
                                <th scope="col">Arrival/ Departure</th>
                                <th scope="col">Passengers</th>
                                <th scope="col">Crew</th>
                                <th scope="col">Total valid </th>
                                <th scope="col">Total errors </th>
                                <th scope="col">Total Cleared</th>
                                <th scope="col">Total Advisory</th>
                                <th scope="col">Total Not Cleared </th>
                                <th scope="col">Contact Info</th>
                                <th scope="col">Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.slice(paginationObject.startIndex, paginationObject.endIndex).map((item, i) => {
                                return (
                                    <tr key={i} className={activeId === i ? 'higlinteActiveRow' : null}>
                                        <td className="col" style={{ textAlign: 'center' }} >                                           
                                            <BsCircleFill className={(item?.totalErrors !== 0 || item?.totalNotCleared !== 0) ? ("error") : 
                                                                    (item?.totalAdvisory !== 0) ?("warning"):("success")} />
                                           
                                        </td>
                                        <td className="col" >
                                            {item.clobReceived === true ? <AiFillCheckCircle style={{ textAlign: 'center' }} className="closeFlight" /> : null}
                                        </td>
                                        <td className="col" >
                                            {item?.flightCode}
                                        </td>
                                        <td className="col" >
                                            {item?.departureAirport}
                                        </td>
                                        <td className="col" >
                                            {item?.arrivalAirport}
                                        </td>
                                        <td className="col" >
                                            
                                            <Moment format="DD MMM yy H:mm A">{item?.flightDateTime.replace(':00Z', '')}</Moment>
                                          
                                        </td>
                                     
                                        <td className="col" >
                                            {item?.departureAirport === "TLV" || item?.departureAirport==="ETH" ||
                                            item?.departureAirport === "VDA" || item?.departureAirport==="AFK" ||
                                            item?.departureAirport === "HFA" || item?.departureAirport==="ETM" ||
                                            item?.departureAirport === "MTZ" || item?.departureAirport==="MIP"
                                            ? (
                                                <span>Departure</span>
                                            ) : (<span>Arrival</span>)}
                                        </td>
                                        <td className="col" >{item?.totalPassengers}</td>
                                        <td className="col" >{item?.totalCrew}</td>
                                        <td className="col" >{item?.totalValid} </td>
                                        <td className="col" >{item?.totalErrors} </td>
                                        <td className="col" >{item?.totalCleared} </td>
                                        <td className="col" >{item?.totalAdvisory}</td>
                                        <td className="col" >{item?.totalNotCleared}</td>
                                        <td className="col" >
                                            <Navbar.Collapse id="basic-navbar-nav">
                                                <Nav className="me-auto">
                                                    <NavDropdown className="m-auto" title="..." id="basic-nav-dropdown">
                                                        <NavDropdown.Item>Name: {item?.contactFirstName}</NavDropdown.Item>
                                                        {item?.contactPhone !== "" && item?.contactPhone !== null ? <NavDropdown.Item>Phone: {item?.contactPhone}</NavDropdown.Item> : null}
                                                        {item?.contactFaxNo !== "" && item?.contactFaxNo !== null ? <NavDropdown.Item>Fax: {item?.contactFaxNo}</NavDropdown.Item> : null}
                                                        {item?.ContactEmail !== "" && item?.ContactEmail !== undefined ? <NavDropdown.Item>Email: {item.ContactEmail}</NavDropdown.Item> : null}
                                                    </NavDropdown>
                                                </Nav>
                                            </Navbar.Collapse>
                                        </td>
                                        <td className="col" >
                                            <Navbar.Collapse id="basic-navbar-nav">
                                                <Nav className="me-auto">
                                                    <NavDropdown className="m-auto" title="..." id="basic-nav-dropdown">
                                                        <NavDropdown.Item id="passengers-menu-item" onClick={() => redirectToPersons(item, "Passenger")} >Passengers</NavDropdown.Item>
                                                        <NavDropdown.Item id="crew-menu-item" onClick={() => redirectToPersons(item, "Crew")}>Crew</NavDropdown.Item>
                                                        {!userInfo.isOwner && <React.Fragment>
                                                            <NavDropdown.Divider />
                                                            {item.clobReceived === false && (<NavDropdown.Item id="update-flight-menu-item" onClick={() => handleUpdateFlight(item, i)}>Update Flight</NavDropdown.Item>)}
                                                            <NavDropdown.Item id="cancel-flight-menu-item" onClick={() => handleShow(item, "cancel", i)}>Cancel Flight</NavDropdown.Item>
                                                            <NavDropdown.Item id="close-flight-menu-item" onClick={() => handleShow(item, "close", i)}>Close Flight</NavDropdown.Item>
                                                            {item?.errorInd === 1 && item?.flight_Errors && (<NavDropdown.Item onClick={() => handleErrors(item)}>Show Errors</NavDropdown.Item>)}
                                                        </React.Fragment>}
                                                    </NavDropdown>
                                                </Nav>
                                            </Navbar.Collapse>
                                        </td>
                                    </tr>
                                )
                            })
                            }
                        </tbody>
                    </table>
                     {!data.length ? <AppTableNoData /> :
                            <AppPagination
                                pageSize={paginationObject.pageSize}
                                totalRecords={data.length}
                                currentPage={paginationObject.currPage}
                                endIndex={paginationObject.endIndex}
                                startIndex={paginationObject.startIndex}
                                setPaginationObject={(ele) => {
                                    setPaginationObject((data) => {
                                        return ({ ...data, pageSize: ele.pageSize, startIndex: ele.startIndex, endIndex: ele.endIndex, currPage: ele.currPage })
                                    })
                                }}
                            ></AppPagination>
                        }
                </React.Fragment>
            )}
        </div>
        <AppButton id="flightListBackBtn" action={backhandler} label="Back" icon={<IoChevronBackCircle />}></AppButton>
        <div>
            <Modal show={showModal} onHide={handleCloseUpdateInsertPerson} backdrop="static">
                <Modal.Header >
                    <Modal.Title>{action} flight</Modal.Title>
                    <span style={{ cursor: "pointer" }} onClick={handleClose}>X</span>
                </Modal.Header>
                <Modal.Body>
                    <NewFlightPopup props={props} onSubmitted={onRowUpdateSubmitted} flight={flight} action={action} />
                </Modal.Body>
            </Modal>
        </div>
        <div>
            <Modal show={showModalForUpdate} onHide={handleCloseUpdateInsertPerson} backdrop="static">
                <Modal.Header >
                    <Modal.Title>{action} flight</Modal.Title>
                    <span style={{ cursor: "pointer" }} onClick={handleClose}>X</span>
                </Modal.Header>
                <Modal.Body>
                    <UpdateFlightPopup props={props} onSubmitted={onRowUpdateSubmitted} flight={flight} action={action} />
                </Modal.Body>
            </Modal>
        </div>
        <div>
            <Modal show={show} onHide={handleCloseUpdateInsertPerson} backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title>Flight</Modal.Title>
                    <span style={{ cursor: "pointer" }} onClick={handleClose}>X</span>
                </Modal.Header>
                <Modal.Body>{message}</Modal.Body>
                <Modal.Footer>
                    <div className="col-2">
                        {showCancelFlightBtn ? (
                            <AppButton action={() => HandleCancelFlight(selectedItem)} label="Yes" isLoading={spinnerLoading} isBlock={true}></AppButton>
                        ) : null}
                        {showCloseFlightBtn ? (
                            <AppButton action={() => handleCloseFlight(selectedItem)} label="Yes" isLoading={spinnerLoading} isBlock={true}></AppButton>
                        ) : null}
                    </div>
                    <div className="col-2">
                        <AppButton action={handleClose} label="No" disabled={spinnerLoading} color="secondary" isBlock={true}></AppButton>
                    </div>
                </Modal.Footer>
            </Modal>
        </div>
           
        <div>
            <Modal show={showModalErrors} onHide={handleCloseErrorModal} backdrop="static" keyboard={false}>
                <Modal.Header>
                    <Modal.Title>Flight Errors</Modal.Title>
                    <span style={{ cursor: "pointer" }} onClick={handleClose}>X</span>
                </Modal.Header>
                <Modal.Body>
                    <FlightErrors data={errorsData}/>
                </Modal.Body>
               
            </Modal>
        </div>
    </>

    )
}
export default FlightList;

